<div class="content">
  <span class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.DESCRIPTION' | translate }}
  </span>

  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.SELECT_ACTIVITY' | translate }}
    </glxy-label>
    <mat-select [formControl]="actionControl" required="true">
      <mat-option *ngFor="let salesActivitiesOption of salesActivitiesOptions" [value]="salesActivitiesOption.value">
        {{ salesActivitiesOption.text | translate }}
      </mat-option>
    </mat-select>
    <glxy-error *ngIf="actionControl.hasError('required')">
      {{ 'COMMON.REQUIRED' | translate }}
    </glxy-error>
  </glxy-form-field>
  <ng-container *ngIf="showCustomActionInput$ | async">
    <glxy-form-field #customAction [required]="true">
      <glxy-label>
        {{ 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.CUSTOM_ACTION' | translate }}
      </glxy-label>
      <input matInput type="text" [formControl]="customActionControl" required="true" />
      <glxy-error *ngIf="customActionControl.hasError('required')">
        {{ 'COMMON.REQUIRED' | translate }}
      </glxy-error>
    </glxy-form-field>
  </ng-container>
  <glxy-form-field required="true">
    <glxy-label>
      {{ 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.ADD_NOTES' | translate }}
    </glxy-label>
    <textarea
      id="notesControl"
      matInput
      [formControl]="notesControl"
      cdkTextareaAutosize
      cdkAutosizeMinRows="4"
      cdkAutosizeMaxRows="8"
      placeholder="{{ 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.ADD_NOTES' | translate }}"
      [required]="true"
    ></textarea>
    <automata-automation-variable-menu
      matSuffix
      useGalaxyCompat="true"
      (variableSelected)="insertVariable('notesControl', notesControl, $event)"
    ></automata-automation-variable-menu>
  </glxy-form-field>
  <mat-slide-toggle [formControl]="statusControl">
    {{ 'AUTOMATIONS.EDITOR.TASKS.LOG_SALES_ACTIVITY.FOLLOW_UP_REQUIRED' | translate }}
  </mat-slide-toggle>
</div>
